import React from "react";
import "./Style.scss";

interface IProps {
  id: string;
  className: string;
  ["data-testid"]?: string;
  children?: React.ReactNode;
}

type Props = React.PropsWithChildren<IProps>;

/**
 * Responsible for render parent report tree view
 */
const TreeList: React.FC<Props> = (props: Props) => {

  return  (
    <ul
      id={props.id}
      data-testid={props["data-testid"]}
      className={ "ebt-tree-list " + props.className }>{props.children}</ul>
  );
};

export default TreeList;
